import ProductListSpecifications from '@app/components/common/ProductListSpecifications';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
  marketingSetQueryParam,
  setMarketingProductCardExpanded,
  getMarketingProductDetails
} from '@app/store/marketing/actions';
import MyEquipmentFilter from '@app/components/common/MyEquipmentFilter';
import { useSelector, useDispatch } from 'react-redux';
import {
  APPLICATION_AND_MATERIAL_FACET_ID,
  PAGE_BREAKPOINTS,
  STATUS
} from '@app/constants/commonConstants';
import { useBreakpoint, usePrevious } from '@app/hooks';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import usePagination from '@app/components/pages/plp/usePagination';
import { isEmpty } from '@app/utils';

const ProductCardSidebar = ({
  isModal,
  widgetId,
  handleEquipmentCheck,
  showLeftNav
}) => {
  const {
    facets,
    activeFacets,
    unitOfMeasure,
    showSpecificationsToggle,
    fbeEnabled,
    filterByEquipment,
    recordSetTotal,
    partNumbers,
    getProductDetailsStatus
  } = useSelector(state =>
    state.marketingLandingPageUI[widgetId]
      ? state.marketingLandingPageUI[widgetId]
      : {}
  );
  const [loadActivefacets, setLoadActivefacets] = useState(true);
  const { hash } = useLocation();
  const equipmentList = useSelector(
    s => s.myEquipment.equipments.myEquipmentList || []
  );
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const dispatch = useDispatch();
  const { selectedEquipment } = useSelector(s => s.myEquipment.equipments);
  const { model, serialNumber } = selectedEquipment ? selectedEquipment : {};
  const isFilterByEquipment = partNumbers && showLeftNav && recordSetTotal > 0;
  const { setUrlToPageOneWithFilter } = usePagination();
  const initialEquipmentLoading = useSelector(
    s => s.myEquipment?.initialLoading
  );
  const uniqueIndex = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.uniqueIndex
  );
  const prevUniqueIndex = usePrevious(uniqueIndex);
  const equipmentChanged = !!(
    !initialEquipmentLoading &&
    getProductDetailsStatus !== STATUS.IDLE &&
    uniqueIndex !== prevUniqueIndex
  );
  const getfilterFromUrl = () => {
    const { filterByEquipment: filterFromHash } = queryString.parse(hash);
    let filterByValue;
    if (
      (!filterFromHash && selectedEquipment) ||
      !filterFromHash.includes(widgetId)
    ) {
      filterByValue = true;
    } else if (filterFromHash && filterFromHash.includes(widgetId)) {
      filterFromHash.split(',').forEach(item => {
        const widgetUrlValue = item.split('|');
        if (widgetUrlValue[1] == widgetId) {
          filterByValue = widgetUrlValue[0] === 'true' ? true : false;
        }
      });
    }
    return filterByValue;
  };
  const getFacetsValueFromUrl = () => {
    const { facets: facetsFromHash } = queryString.parse(hash);
    let facetsArray = [];
    if (facetsFromHash) {
      const newFacetsFromHash = Array.isArray(facetsFromHash)
        ? facetsFromHash
        : [facetsFromHash];
      if (newFacetsFromHash) {
        newFacetsFromHash.forEach(item => {
          const widgetUrlValue = item.split('|');
          if (widgetUrlValue[1] == widgetId) {
            facetsArray.push({ facet: widgetUrlValue[0] });
          }
        });
      }
    }
    return facetsArray;
  };
  const filterFromUrl = getfilterFromUrl();
  useEffect(() => {
    const facetsFromUrl = getFacetsValueFromUrl();
    isFilterByEquipment &&
      dispatch(
        marketingSetQueryParam({
          widgetId: widgetId,
          data: {
            pageNumber: 1,
            batchPartNumbers: [],
            filterByEquipment: filterFromUrl,
            activeFacets: activeFacets.length ? activeFacets : facetsFromUrl
          }
        })
      );
    isFilterByEquipment &&
      dispatch(getMarketingProductDetails(partNumbers, widgetId));
  }, [
    widgetId,
    partNumbers,
    filterByEquipment,
    selectedEquipment,
    dispatch,
    isFilterByEquipment
  ]);
  // this use effect will trigger the redraw if equipment changes
  useEffect(() => {
    const { orderBy: orderByFromUrl } = queryString.parse(hash);
    const facetsFromUrl = getFacetsValueFromUrl();
    if (equipmentChanged) {
      // when selecting equipment when none is selected we mimic checking the check to update redux, url and fetch
      if (prevUniqueIndex) {
        handleEquipmentCheck(true);
        // when selecting different equipment or deselecting
      } else {
        // update the url to remove filterByEquipment param when deselecting equipment
        if (!uniqueIndex) {
          setUrlToPageOneWithFilter({
            removeFilterByEquipment: true
          });
        }
      }
    }
  }, [
    dispatch,
    filterByEquipment,
    equipmentChanged,
    uniqueIndex,
    setUrlToPageOneWithFilter,
    handleEquipmentCheck
  ]);

  useEffect(() => {
    if (loadActivefacets && activeFacets?.length && facets.length) {
      let updatedActiveFacet = [];
      facets.forEach(facet => {
        facet.value.forEach(value => {
          if (facet.facetId === APPLICATION_AND_MATERIAL_FACET_ID) {
            Object.values(value).forEach(item => {
              item.forEach(i => {
                activeFacets.forEach(f => {
                  if (i.facet === f.facet) {
                    updatedActiveFacet.push(i);
                  }
                });
              });
            });
          } else if (!isEmpty(value?.values)) {
            value.values.map(subfacet => {
              activeFacets.forEach(f => {
                if (subfacet.facet === f.facet) {
                  updatedActiveFacet.push(subfacet);
                }
              });
            });
          } else {
            let facetValueId = value.facet;
            activeFacets.forEach(f => {
              if (facetValueId === f.facet) {
                updatedActiveFacet.push(value);
              }
            });
          }
        });
      });
      dispatch(
        marketingSetQueryParam({
          widgetId: widgetId,
          data: {
            activeFacets: updatedActiveFacet
          }
        })
      );
      setLoadActivefacets(false);
    }
  }, [facets]);
  return (
    <div
      className="col-12 px-0 d-flex flex-column col-md-3"
      data-testid="LeftNav"
    >
      {fbeEnabled && (
        <div className="order-1 order-md-0">
          <MyEquipmentFilter
            equipmentList={equipmentList}
            recordSetTotal={recordSetTotal}
            model={model}
            serialNumber={serialNumber}
            checked={filterFromUrl ?? filterByEquipment}
            onCheck={handleEquipmentCheck}
            widgetId={widgetId}
          />
        </div>
      )}
      {isMD && (
        <ProductListSpecifications
          facets={facets}
          isModal={isModal}
          unitOfMeasure={unitOfMeasure}
          activeFacets={activeFacets}
          queryActionParam={marketingSetQueryParam}
          productCardExpanded={setMarketingProductCardExpanded}
          showSpecificationsToggle={showSpecificationsToggle}
          widgetId={widgetId}
          fbeEnabled={fbeEnabled}
        />
      )}
    </div>
  );
};
ProductCardSidebar.propTypes = {
  widgetId: PropTypes.string,
  isModal: PropTypes.bool,
  handleEquipmentCheck: PropTypes.func
};

export default ProductCardSidebar;
